/* eslint-disable */
import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getTranslations } from "../../../../services/languageUtils";

class Step3 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dangerPassword: false,
      dangerPasswordConfirm: false,
      dangerPin: false,
      dangerPinConfirm: false,
      enableViewPassword: false,
      enableViewRetypePassword: false,

      pin: this.props.pin || "",
      pinConfirm: "",
      password: this.props.password || "",
      passwordConfirm: this.props.password || "",

      translations: {},
    };
  }

  loadTranslations = async () => {
    const translations = await getTranslations(
      localStorage.getItem("language") || "pt",
    );
    this.setState({ translations });
  };

  componentDidMount() {
    this.loadTranslations();
  }

  hasUppercase(value) {
    return /[A-Z]/.test(value);
  }

  hasLowercase(value) {
    return /[a-z]/.test(value);
  }

  hasNumber(value) {
    return /[0-9]/.test(value);
  }

  hasSpecialChar(value) {
    return /\W|_/.test(value);
  }

  isValidPassword(value) {
    return (
      value.length >= 8 &&
      this.hasUppercase(value) &&
      this.hasLowercase(value) &&
      this.hasNumber(value) &&
      this.hasSpecialChar(value)
    );
  }

  handleChangePin = (e) => {
    const { value } = e.target;
    if (/^\d{0,6}$/.test(value)) {
      this.setState({
        dangerPin: false,
        pin: value,
      });
    }
  };

  handleChangePinAgain = (e) => {
    const { value } = e.target;
    if (/^\d{0,6}$/.test(value)) {
      this.setState({
        dangerPinConfirm: false,
        pinConfirm: value,
      });
    }
  };

  handleChangePassword = (e) => {
    const value = e.target.value;
    this.setState({
      password: value,
      dangerPassword: false,
    });
  };

  handleChangePasswordConfirm = (e) => {
    const value = e.target.value;
    this.setState({
      passwordConfirm: value,
      dangerPasswordConfirm: false,
    });
  };

  nextStep() {
    const { pin, pinConfirm, password, passwordConfirm, translations } =
      this.state;

    if (pin.length < 6) {
      toast.error(
        translations.shortPin || "O PIN deve conter 6 dígitos numéricos.",
      );
      this.setState({ dangerPin: true });
      return;
    }

    if (pin !== pinConfirm) {
      toast.error(translations.pinDontMatch || "Os PINs não coincidem.");
      this.setState({ dangerPin: true, dangerPinConfirm: true });
      return;
    }

    if (password !== passwordConfirm) {
      toast.error(
        translations.passwordsDontMatch || "As senhas não coincidem.",
      );
      this.setState({
        dangerPassword: true,
        dangerPasswordConfirm: true,
      });
      return;
    }

    if (password.length < 8) {
      toast.error(
        translations.passwordTooShort ||
          "A senha deve ter pelo menos 8 caracteres.",
      );
      this.setState({
        dangerPassword: true,
        dangerPasswordConfirm: true,
      });
      return;
    }

    if (!this.hasUppercase(password)) {
      toast.error(
        translations.passwordMustContainUppercase ||
          "A senha deve conter pelo menos uma letra maiúscula.",
      );
      this.setState({
        dangerPassword: true,
        dangerPasswordConfirm: true,
      });
      return;
    }

    if (!this.hasLowercase(password)) {
      toast.error(
        translations.passwordMustContainLowercase ||
          "A senha deve conter pelo menos uma letra minúscula.",
      );
      this.setState({
        dangerPassword: true,
        dangerPasswordConfirm: true,
      });
      return;
    }

    if (!this.hasNumber(password)) {
      toast.error(
        translations.paswordMustContainNumbers ||
          "A senha deve conter pelo menos um número.",
      );
      this.setState({
        dangerPassword: true,
        dangerPasswordConfirm: true,
      });
      return;
    }

    if (!this.hasSpecialChar(password)) {
      toast.error(
        translations.passwordMustContainSpecialCharacters ||
          "A senha deve conter pelo menos um caractere especial.",
      );
      this.setState({
        dangerPassword: true,
        dangerPasswordConfirm: true,
      });
      return;
    }

    this.props.onChangeValue({
      target: { name: "pin", value: pin },
    });

    this.props.onChangeValue({
      target: { name: "password", value: password },
    });

    this.props.onChangeValue({
      target: { name: "step", value: 4 },
    });
  }

  render() {
    const {
      translations,
      dangerPin,
      dangerPinConfirm,
      dangerPassword,
      dangerPasswordConfirm,
      enableViewPassword,
      enableViewRetypePassword,
      pin,
      pinConfirm,
      password,
      passwordConfirm,
    } = this.state;

    return (
      <div className="sideRightContent">
        <div className="textContentSteps">
          <div className="h1">
            <div className="h1Label">
              <img
                src={
                  require("../../../../assets/imgs/ico-higher-titulo.svg")
                    .default
                }
                alt="Logo Higher"
                className="titleImage"
              />
            </div>
            <div className="h1LabelMobile">3</div>
            {translations.accountAccess || "Acesso à Conta"}
          </div>
          <br />

          <div className="contentInputText" style={{ maxWidth: "315px" }}>
            <p className="label">
              {translations.typeYourPin || "Digite seu PIN"}
            </p>
            <input
              value={pin}
              className={`input ${dangerPin ? "inputDanger" : ""}`}
              maxLength={6}
              name="pin"
              id="pin"
              type="password"
              inputMode="numeric"
              onChange={this.handleChangePin}
            />
            <span
              style={{
                color: "#696C70",
                fontSize: "12px",
                display: "block",
                marginTop: "5px",
              }}
            >
              {translations.pinHelperText ||
                "PIN de transações com 6 dígitos numéricos."}
            </span>
          </div>

          <div className="contentInputText" style={{ maxWidth: "315px" }}>
            <p className="label">
              {translations.retypeYourPin || "Digite seu PIN novamente"}
            </p>
            <input
              value={pinConfirm}
              className={`input ${dangerPinConfirm ? "inputDanger" : ""}`}
              maxLength={6}
              name="pinAgain"
              id="pinAgain"
              type="password"
              inputMode="numeric"
              onChange={this.handleChangePinAgain}
            />
          </div>

          <p className="h5">
            <br />
            {translations.defineYourPasswordAccess ||
              "Defina sua senha de acesso"}
          </p>

          <div className="labelPassword">
            {translations.passwordSecurityRecommendation ||
              "Recomendamos pelo menos 8 caracteres, incluindo letra maiúscula, letra minúscula, número e caractere especial."}
          </div>

          <div className="contentInputText" style={{ maxWidth: "315px" }}>
            <p className="label">
              {translations.typeYourPassword || "Digite sua senha"}
            </p>
            <div
              style={{
                cursor: "pointer",
                position: "absolute",
                right: "20px",
                top: "40px",
              }}
            >
              {enableViewPassword ? (
                <img
                  src={
                    require("../../../../assets/imgs/open-eye.svg").default
                  }
                  alt="Ícone visualizar senha"
                  className="iconPasswordInput"
                  onClick={() =>
                    this.setState({
                      enableViewPassword: !enableViewPassword,
                    })
                  }
                />
              ) : (
                <img
                  src={
                    require("../../../../assets/imgs/close-eye.svg").default
                  }
                  alt="Ícone visualizar senha"
                  className="iconPasswordInput"
                  style={{ marginTop: "5px" }}
                  onClick={() =>
                    this.setState({
                      enableViewPassword: !enableViewPassword,
                    })
                  }
                />
              )}
            </div>

            <input
              value={password}
              className={`input ${dangerPassword ? "inputDanger" : ""}`}
              maxLength={25}
              name="newPassword"
              id="newPassword"
              type={!enableViewPassword ? "password" : "text"}
              onChange={this.handleChangePassword}
              onBlur={() => {
                this.props.sendActiveEvent("PF_Senha");
              }}
            />
          </div>

          <div className="contentInputText" style={{ maxWidth: "315px" }}>
            <p className="label">
              {translations.retypeYourPassword || "Digite sua senha novamente"}
            </p>
            <div
              style={{
                cursor: "pointer",
                position: "absolute",
                right: "20px",
                top: "40px",
              }}
            >
              {enableViewRetypePassword ? (
                <img
                  src={
                    require("../../../../assets/imgs/open-eye.svg").default
                  }
                  alt="Ícone visualizar senha"
                  onClick={() =>
                    this.setState({
                      enableViewRetypePassword: !enableViewRetypePassword,
                    })
                  }
                />
              ) : (
                <img
                  src={
                    require("../../../../assets/imgs/close-eye.svg").default
                  }
                  alt="Ícone visualizar senha"
                  style={{ marginTop: "5px" }}
                  onClick={() =>
                    this.setState({
                      enableViewRetypePassword: !enableViewRetypePassword,
                    })
                  }
                />
              )}
            </div>

            <input
              value={passwordConfirm}
              className={`input ${dangerPasswordConfirm ? "inputDanger" : ""}`}
              maxLength={25}
              name="newPasswordAgain"
              id="newPasswordAgain"
              type={!enableViewRetypePassword ? "password" : "text"}
              onChange={this.handleChangePasswordConfirm}
              onBlur={() => {
                this.props.sendActiveEvent("PF_Confirmar_senha");
              }}
            />
          </div>
        </div>

        <div className="lineBtnSaveAndContinue">
          <div
            className="btnBack"
            onClick={() => {
              this.props.onChangeValue({
                target: { name: "step", value: 2 },
              });
            }}
          >
            {translations.goBack || "Voltar"}
            <div className="arrow">
              <img
                src={
                  require("../../../../assets/imgs/seta-left-cinza.svg")
                    .default
                }
                alt="Seta anterior"
                className="arrowBack"
              />
            </div>
            <div className="space"></div>
          </div>

          <div
            className="btnSaveAndContinue"
            onClick={() => {
              this.nextStep();
            }}
          >
            {translations.saveAndProceed || "Salvar e continuar"}
            <div className="arrow">
              <img
                src={
                  require("../../../../assets/imgs/seta-right-branca.svg")
                    .default
                }
                alt="Seta próximo"
                className="arrowNext"
              />
            </div>
          </div>
        </div>

        <ToastContainer />
      </div>
    );
  }
}

export default Step3;
